import { Link } from "react-router-dom";

export default function LegalMentionsPage() {
    return (
        <div className="h-full w-full p-12 bg-white dark:bg-black text-black dark:text-white">
            <h1 className="text-4xl font-bold text-center">
                Mentions légales
            </h1>
            <Link to="/confidentialite">
                <p className="underline text-secondary">
                    Règles de confidentialité
                </p>
            </Link>
        </div>
    );
}